export default __webpack_public_path__ + "static/media/dislike.22d18f41.svg";